export default {
  getSalons(state) {
    return state.salons;
  },
  getSalonDetails(state) {
    return state.salonDetails;
  },
  getVoucherStock: state => salonId => state.voucherStocksBySalonId[salonId]
  
}
